import { args } from '../../../common/args';
export const onSalesExtensionEmptyStateEligibilityResponse = {
  onSalesExtensionEmptyStateEligibilityResponse: {
    args: {
      shouldShowEmptyState: args.bool()
    }
  }
};